module.exports = __webpack_public_path__ + "img/am_logo.3fe58a61.png";